<template>
  <form action="/konfigurator_php/actionmodul/createpdf/createpdf.php" method="post" target="_blank" id="pdfCreation">
    <input name="login" id="pdfcreation_login" type="hidden">
    <input name="product" id="pdfcreation_product" type="hidden">
    <input name="saveid" id="pdfcreation_saveid" type="hidden">
    <input name="datumstring" id="pdfcreation_datumstring" type="hidden">
    <input name="entwurfname" id="pdfcreation_entwurfname" type="hidden">
    <input name="images" id="pdfcreation_images" type="hidden">
    <input name="infoadresse" id="pdfcreation_infoadresse" type="hidden">
    <input name="loginLabel" type="hidden" :value="$t('konf_Login')">
    <input name="saveIDLabel" type="hidden" :value="$t('konf_SaveID')">
    <input name="productLabel" type="hidden" :value="$t('konf_Produkt')">
    <input name="entwurfNameLabel" type="hidden" :value="$t('konf_entwurf')">
    <input name="language" type="hidden" id="pdfcreation_sprache">
  </form>


</template>

<script lang="ts" setup>
</script>

<style scoped>
form {
  display: none;
}
</style>